var RouterPath;
(function (RouterPath) {
    RouterPath["OVERVIEW"] = "overview";
    RouterPath["USER_PANEL"] = "userpanel";
    RouterPath["ADMIN_PANEL"] = "adminpanel";
    RouterPath["PASSWORD"] = "password";
})(RouterPath || (RouterPath = {}));
/**
 * Abas do painel de configurações (V3). Elas só renderizam dentro do
 * UserLegacy.vue — ou seja, para quem NÃO tem a flag `new_settings_page`.
 * A versão nova é servida exclusivamente pelo UserReborn.vue (iframe do
 * atlas-reborn em /overview), que é dono da própria navegação interna.
 *
 * Portanto estas rotas devem apontar sempre para os componentes V3: um iframe
 * do reborn aqui vaza a nova versão para contas sem a flag (o switcher de
 * User.vue não alcança o conteúdo das abas).
 */
export const UserRouter = [
    {
        path: '',
        redirect: { path: RouterPath.OVERVIEW },
    },
    {
        path: `${RouterPath.OVERVIEW}`,
        component: () => import(
        /* webpackChunkName: 'overview' */ '@/modules/subscriptions/containers/AccountInformation.container.vue'),
        name: 'overview',
    },
    // {
    //   path: RouterPath.USER_PANEL,
    //   component: () =>
    //     import(/* webpackChunkName: 'userpanel' */ './views/UserPanel.view.vue'),
    //   beforeEnter: UsersGuard.all
    // },
    {
        path: RouterPath.ADMIN_PANEL,
        component: () => import(
        /* webpackChunkName: 'adminpanel' */ '@/modules/users/containers/UserAdminPanelContainer.vue'),
        // beforeEnter: UsersGuard.all,
        name: 'adminpanel',
    },
    {
        path: RouterPath.PASSWORD,
        component: () => import(
        /* webpackChunkName: 'password' */ '@/modules/users/containers/UserChangePasswordContainer.vue'),
        // beforeEnter: UsersGuard.all,
        name: 'password',
    },
    {
        path: 'config/api-token-export',
        component: () => import(
        /* webpackChunkName: 'apiTokenExport' */ '@/modules/users/containers/IntegratedCRMList.container.vue'),
        // beforeEnter: UsersGuard.all,
        name: 'apiTokenExport',
    },
    {
        path: 'share-and-win',
        component: () => import('@/modules/users/containers/Shareandwin.container.vue'),
        name: 'share-and-win',
    },
    {
        path: 'my_preferences',
        component: () => import('@/modules/users/containers/MyPreferences.container.vue'),
        name: 'my_preferences',
    },
    {
        path: 'handoff',
        component: () => import('@/modules/users/containers/Handoff.container.vue'),
        name: 'handoff',
    },
];
